// material-ui
import { alpha, Theme } from "@mui/material/styles";

// ==============================|| OVERRIDES - DIALOG CONTENT ||============================== //

export default function DialogContent(theme: Theme) {
  return {
    MuiDialogContent: {
      styleOverrides: {
        root: {
          position: "relative",
          padding: theme.spacing(2.5, 3, 2.5),
          backgroundColor: alpha(theme.palette.background.paper, 0.76),
          "&:first-of-type": {
            paddingTop: theme.spacing(2.5),
          },
          "&::-webkit-scrollbar": {
            width: 10,
            height: 10,
          },
          "&::-webkit-scrollbar-thumb": {
            borderRadius: 999,
            border: `2px solid ${alpha(theme.palette.background.paper, 0.88)}`,
            backgroundColor: alpha(theme.palette.primary.main, 0.22),
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: alpha(theme.palette.primary.light, 0.08),
          },
        },
        dividers: {
          borderTopColor: alpha(theme.palette.primary.main, 0.08),
          borderBottomColor: alpha(theme.palette.primary.main, 0.08),
        },
      },
    },
  };
}
